import { ServerError, ValidationError } from "shared/constants/errorTypes";

import Validation from "shared/constants/validationMessages";
import { useErrors } from "shared/hooks/errors/useErrors";

export const useValidationError = () => {
    const { handleError } = useErrors();

    const handleFormErrorResponse = (error, setError) => {
        if (
            error instanceof ServerError &&
            error.status &&
            error?.status &&
            error?.status === 400
        ) {
            const verror = new ValidationError(
                Validation.validation,
                error.status,
                error.correlationId,
                error.body
            );
            processValidationError(verror, setError);
            return false;
        } else if (error instanceof ValidationError) {
            processValidationError(error, setError);
            return false;
        } else {
            handleError(error);
            return true;
        }
    };

    const processValidationError = (error, setError) => {
        Object.keys(error.body).forEach((key) => {

            // first we make sure first letter of the field is lowercase
            const fieldName = key.charAt(0).toLowerCase() + key.slice(1);
            const errorMessage = error.body[key];
            const errorObject = { type: "manual", message: errorMessage };

            setError(fieldName, errorObject);
        });
    };

    return { handleFormErrorResponse };
};
